export { default } from './CaptureThumbnail';
